import { Component } from 'react';

import Image from 'components/atoms/Image';
import { translate } from 'utils/translate';

import { SETTINGS } from '../../settings';
import updatePageTitle from 'utils/document';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface HomeState {}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface HomeProps {}

class Home extends Component<HomeProps, HomeState> {
    componentDidMount(): void {
        updatePageTitle('Login · TransitAnalyst');
    }

    render() {
        return (
            <section className="fixed w-screen h-screen left-0 top-0">
                <Image
                    alt={translate('transit analysis')}
                    className="w-full select-non z-0 h-full object-cover absolute left-0 top-0"
                    src="/static/images/hero.jpg"
                />
                <div className="text-center px-4 fixed w-1/4 bg-white left-0 top-0 h-screen z-10 flex justify-center items-center">
                    <div className="center">
                        <Image
                            style={{ width: 300 }}
                            className="w-auto ml-auto mr-auto  -mt-10"
                            src="/static/images/logo.svg"
                            alt={translate('transit analysis')}
                        />
                        <div className="mt-5 w-24 m-auto">
                            <div className="mt-3 rounded-md shadow">
                                <a
                                    href={`${SETTINGS.BASE_URL}login`}
                                    className="w-full flex items-center justify-center px-8 py-2 border border-transparent text-base font-medium rounded-md text-white bg-primary-systemColor md:py-2 md:text-lg md:px-10"
                                >
                                    {translate('Login')}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Home;
